import { render, staticRenderFns } from "./DocsList.vue?vue&type=template&id=322cb29f&"
import script from "./DocsList.vue?vue&type=script&lang=js&"
export * from "./DocsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports